import React from 'react'
import { connect } from 'react-redux'
import { branch, compose, renderComponent } from 'recompose'
import { sessionActions, sessionSelectors } from './redux'
import sessionMenuItemLifecycle from './SessionMenuItemLifecycle'
import SessionMenuItem from './SessionMenuItem'
import Loading from '../../components/Loading'
import {opticianActions, opticianSelectors} from "../optician/redux";
import {careUnitActions, careUnitSelectors} from "../careUnit/redux";

const mapStateToProps = (state) => ({
    loggedInUser: sessionSelectors.loggedInUser(state),
    role: sessionSelectors.role(state),
    organizationName: sessionSelectors.organizationName(state),
    isLoggingOut: sessionSelectors.loggingOut(state),
    checkingSession: sessionSelectors.checkingSession(state),
    sessionChecked: sessionSelectors.sessionChecked(state),
    opticianProfileDialogOpen: opticianSelectors.profileDialogOpen(state),
    careUnitProfileDialogOpen: careUnitSelectors.profileDialogOpen(state),
});

const mapDispatchToProps = (dispatch) => ({
    onLogInClicked: () => dispatch(sessionActions.logIn()),
    onLogOutClicked: () => dispatch(sessionActions.logOut()),
    onCheckSession: () => dispatch(sessionActions.checkSession()),
    onUpdateOrganizationClicked: (role) => {
        switch(role) {
            case 'CARE_UNIT':
            case 'CARE_UNIT_ADMIN':
                dispatch(careUnitActions.openProfileDialog())
                break;
            case 'OPTICIAN':
            case 'OPTICIAN_ADMIN':
                dispatch(opticianActions.openProfileDialog())
                break;
            default:
                break;
        }
    },
});

export default compose (
    connect(mapStateToProps, mapDispatchToProps),
    sessionMenuItemLifecycle,
    branch(({isLoggingOut}) => isLoggingOut,
        renderComponent(({loggedInUser})=><Loading title={'Loggar ut ' + loggedInUser + '...'}/>)
    )
)(SessionMenuItem)